import Handlebars from 'handlebars';

export const validateHandlebarsValue = (value) => {
  if (!value) return null;
  try {
    Handlebars.parse(value);
    return null;
  } catch (e) {
    return `Invalid merge tag: ${e.message.split('\n')[0]}`;
  }
};
